export default "__VITE_ASSET__BxYeOzu5__"